/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{FC} from "react";
import { KTIcon } from "../../../../../_metronic/helpers";
import IssueAreasTable from "./IssueAreasTable";

const IssueAreasCard: FC =  () => {
  return (
    <div className={`card mb-5 mb-xl-8`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Issue Areas Management</span>
            <span className='text-muted mt-1 fw-semibold fs-7'></span>
          </h3>
          <div className='card-toolbar'>
            {/* begin::Menu */}
            <button
              type='button'
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTIcon iconName='category' className='fs-2' />
            </button>
            {/* begin::Menu 2 */}
            <div
              className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold w-200px'
              data-kt-menu='true'
            >
              {/* begin::Menu item */}
              <div className='menu-item px-3'>
                <div className='menu-content fs-6 text-dark fw-bold px-3 py-4'>Quick Actions</div>
              </div>
              {/* end::Menu item */}
              {/* begin::Menu separator */}
              <div className='separator mb-3 opacity-75'></div>
              {/* end::Menu separator */}
              {/* begin::Menu item */}
              <div className='menu-item px-3'>
                <a href='#' className='menu-link px-3'>
                  Expand All
                </a>
              </div>
              {/* end::Menu item */}
              {/* begin::Menu item */}
              <div className='menu-item px-3'>
                <a href='#' className='menu-link px-3'>
                  Hide All
                </a>
              </div>
              <div className='menu-item px-3'>
                <a href='#' className='menu-link px-3'>
                  Export
                </a>
              </div>
              {/* end::Menu item */}
             
            </div>
            {/* end::Menu 2 */}
            {/* end::Menu */}
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <IssueAreasTable/>
          </div>
        </div>
        {/* begin::Body */}
      </div>
  )
}

export default IssueAreasCard